package br.com.texeratx.boardgametimeapp.core.di

import br.com.texeratx.boardgametimeapp.data.repository.GameRepository
import br.com.texeratx.boardgametimeapp.data.repository.UploadRepository
import br.com.texeratx.boardgametimeapp.domain.usecases.games.CreateGameUseCase
import br.com.texeratx.boardgametimeapp.domain.usecases.games.DeleteGameUseCase
import br.com.texeratx.boardgametimeapp.domain.usecases.games.GetGameCategoriesUseCase
import br.com.texeratx.boardgametimeapp.domain.usecases.games.GetGameDetailUseCase
import br.com.texeratx.boardgametimeapp.domain.usecases.games.GetGameModesUseCase
import br.com.texeratx.boardgametimeapp.domain.usecases.games.GetGamesUseCase
import br.com.texeratx.boardgametimeapp.domain.usecases.games.SearchCatalogUseCase
import br.com.texeratx.boardgametimeapp.domain.usecases.games.UpdateGameUseCase
import br.com.texeratx.boardgametimeapp.domain.usecases.player.GetPlayersNameUseCase
import br.com.texeratx.boardgametimeapp.domain.usecases.upload.UploadGameImageUseCase
import br.com.texeratx.boardgametimeapp.ui.screens.games.GamesViewModel
import br.com.texeratx.boardgametimeapp.ui.screens.games.create.CreateGameViewModel
import br.com.texeratx.boardgametimeapp.ui.screens.games.detail.GameDetailViewModel
import br.com.texeratx.boardgametimeapp.ui.screens.games.edit.EditGameViewModel
import org.koin.dsl.module

val gamesModule = module {

    factory { GameRepository(get(), get()) }

    factory { GetGamesUseCase(get()) }
    factory { GetGameCategoriesUseCase(get()) }
    factory { GetGameModesUseCase(get()) }
    factory { UpdateGameUseCase(get()) }
    factory { GetGameDetailUseCase(get()) }
    factory { DeleteGameUseCase(get()) }
    factory { SearchCatalogUseCase(get()) }

    factory { GamesViewModel(get()) }

    factory { UploadRepository(get(), get()) }
    factory { UploadGameImageUseCase(get()) }

    factory {
        GameDetailViewModel(
            get(),
            get(),
        )
    }

    factory {
        CreateGameViewModel(
            get(), // CreateGameUseCase
            get(), // GetGameModesUseCase
            get(), // GetGameCategoriesUseCase
            get(), // GetPlayersNameUseCase
            get(), // SearchCatalogUseCase
            get()  // LanguageManager
        )
    }

    factory { CreateGameUseCase(get()) }

    factory { GetPlayersNameUseCase(get()) }

    factory {
        EditGameViewModel(
            get(), // GetGameDetailUseCase
            get(), // GetGameModesUseCase
            get(), // GetGameCategoriesUseCase
            get(), // GetPlayersNameUseCase
            get(), // UpdateGameUseCase
            get()  // LanguageManager
        )
    }
}
